$(document).ready(function () {

    var first_inv = $('.cv_repeat_cart[data-line="1"]').attr('data-quantity');
    var sec_inv = $('.cv_repeat_cart[data-line="2"]').attr('data-quantity');
    var data_lenght = $('.cv_repeat_cart').length;

    if (data_lenght == 1) {
        var data_image = $('.cv_repeat_cart').attr('data-image');
        var data_title = $('.cv_repeat_cart').attr('data-title')
        $('.Cv_left_bar_image img').attr('src', data_image);
        $('.upsell_title').html(data_title);
        $('.cv_custom_pair_product_content').hide();
        $('.cv_custom_single_product_content').show();
        $('.cv_custom_pair_product_content').hide();
        $('.cv_custom_single_product_content').show();
    } else {
        $('.cv_custom_pair_product_content').show();
        $('.cv_custom_single_product_content').hide();
    }

    $(document).on('click', '.CV_side_cart_close .side-cart-close', function (e) {
        e.preventDefault();
        $('.cart_drawer').removeClass('cart_drawer_open');
        $('html').removeClass('drawer_open_overlay');
    });

    $(document).on('click ', '.cv_Custom_mobile_cart_part', function (e) {
        e.preventDefault();
        console.log('Yes');
        setTimeout(function () {
            $('.cv_Custom_desktop_cart_part').show();
        }, 100);
        $('.icon-hamburger').toggle();
        $('.mobile-nav-wrapper').toggleClass('cv_Custom_open_nav');
        $('html').removeClass('cv_Custom_menu_bar_overlay');
        setTimeout(function () {
            $('.cart_drawer').addClass('cart_drawer_open');
            $('html').addClass('drawer_open_overlay');
        }, 100);
    });
})

$(document).on('click', '.cv_custom_Collection_add_to_btn, .product-form__cart-submit', function (e) {
    e.preventDefault();
    var cv_main_product_id = $(this).attr('data-variant-id');
    console.log(cv_main_product_id);
    var FormSerialize = $(this).parents('form').serialize();
    $('.cart_drawer').removeClass('cv_Custom_With_out_left_bar');
    $('.CV__left_cart_bar').removeClass('cv_open_left_bar_Cart');
    $.ajax({
        url: '/cart/add',
        type: 'POST',
        dataType: 'HTML',
        data: FormSerialize,
        success: function (response) {
            $('#cartForm').load(' #cartForm');
            $('#CartCount').html($(response).find('#CartCount').html())
            $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('cart_drawer_open');
            $('html').addClass('drawer_open_overlay');

            if (cv_main_product_id == 35481337888924) {
                $('.upsell_outer').addClass('hide');
            } else {
                $('.upsell_outer').removeClass('hide');
            }

            var first_inv = $('.cv_repeat_cart[data-line="1"]').attr('data-quantity');
            var sec_inv = $('.cv_repeat_cart[data-line="2"]').attr('data-quantity');
            var data_lenght = $('.cv_repeat_cart').length;
            if (data_lenght == 2) {
                if (!(first_inv == sec_inv)) {
                    $('.upsell_outer').addClass('hide');
                    $('.cv_custom_pair_product_content').show();
                    $('.cv_custom_single_product_content').hide();
                    $('.cv_custom_right_Contents_cart_mini').addClass('cv_custom_right_contente_full_width');
                }
            }

            if (data_lenght == 1) {
                var data_image = $('.cv_repeat_cart').attr('data-image');
                var data_title = $('.cv_repeat_cart').attr('data-title')
                $('.Cv_left_bar_image img').attr('src', data_image);
                $('.upsell_title').html(data_title);
                $('.cv_custom_pair_product_content').hide();
                $('.cv_custom_single_product_content').show();
            } else {
                $('.cv_custom_pair_product_content').show();
                $('.cv_custom_single_product_content').hide();
            }

        }
    });
})

$(document).on('click', '.cv_Custom_desktop_cart_part', function (e) {
    e.preventDefault();
    $('.cart_drawer').addClass('cart_drawer_open');
    $('html').addClass('drawer_open_overlay');
});

$(document).click(function (e) {
    if (!$(e.target).closest('.cart_drawer, .cv_Custom_desktop_cart_part').length) {
        $('.cart_drawer').removeClass('cart_drawer_open');
        $('html').removeClass('drawer_open_overlay');
    }
});

$(document).on('click', '.cart__remove', function (e) {
    e.preventDefault();
    $("#overlay").show();
    $('#overlay_id').show();
    var url = $(this).attr('href');
    $.ajax({
        url: url,
        type: 'GET',
        success: function (response) {
            $('.site-header__cart-count').html($(response).find('.site-header__cart-count').html())
            $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('cart_drawer_open');
            $('.cv_custom_right_Contents_cart_mini').addClass('cv_custom_right_contente_full_width');
            var first_inv = $('.cv_repeat_cart[data-line="1"]').attr('data-quantity');
            var sec_inv = $('.cv_repeat_cart[data-line="2"]').attr('data-quantity');
            var data_lenght = $('.cv_repeat_cart').length;
            if (data_lenght == 2) {
                if (!(first_inv == sec_inv)) {
                    $('.upsell_outer').addClass('hide');
                    $('.cv_custom_right_Contents_cart_mini').addClass('cv_custom_right_contente_full_width');
                    $('.cv_custom_pair_product_content').show();
                    $('.cv_custom_single_product_content').hide();
                }
            }

            if (data_lenght == 1) {
                var data_image = $('.cv_repeat_cart').attr('data-image');
                var data_title = $('.cv_repeat_cart').attr('data-title')
                $('.Cv_left_bar_image img').attr('src', data_image);
                $('.upsell_title').html(data_title);
                $('.cv_custom_pair_product_content').hide();
                $('.cv_custom_single_product_content').show();
            }

            $('html').addClass('drawer_open_overlay');
            $("#overlay").hide();

        }
    });
});
// quantity Increment
$(document).on('click', '.cv_cart_draweradd', function (e) {
    e.preventDefault();

    var $item = $(this).closest('.side-cart-container__products-item');
    var line = $item.data('line'); // the correct Shopify line number

    var $qtyContainer = $(this).closest('.products-item-desc__qty-container');
    var $qtyInput = $qtyContainer.find('input.cart__qty-input');
    var $qtySpan = $qtyContainer.find('span[data-quantity-input]');
    var $totalPriceElement = $item.find('.side-cart-container__total-price .theme-money');

    var currentQuantity = parseInt($qtyInput.val(), 10);

    // Extract price
    var priceParts = $totalPriceElement.text().split(' = ');
    var pricePerItem = parseFloat(
        priceParts[0].replace('₹', '').replace(/,/g, '').trim()
    );

    if (!isNaN(currentQuantity) && !isNaN(pricePerItem)) {

        var newQuantity = currentQuantity + 1;

        // Update UI instantly
        $qtyInput.val(newQuantity);
        $qtySpan.text(newQuantity);

        // Update price visually
        var newTotalPrice = pricePerItem * newQuantity;
        var newTotalPriceFormatted =
            '₹ ' + newTotalPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');

        $totalPriceElement.text(priceParts[0] + ' = ' + newTotalPriceFormatted);

        // -------------------------------
        // ✅ REAL SHOPIFY CART UPDATE
        // -------------------------------
        $.ajax({
            url: '/cart/change.js',
            type: 'POST',
            dataType: 'json',
            data: {
                line: line,
                quantity: newQuantity
            },
            success: function (cart) {
                console.log('✔ Cart updated successfully', cart);

                // Optional: update cart header count if you want
                if (cart && cart.item_count !== undefined) {
                    $('.site-header__cart-count').text(cart.item_count);
                }
            },
            error: function (error) {
                console.error('❌ Error updating cart:', error);
            }
        });
    } else {
        console.log('⚠️ Current quantity or price is not a number.');
    }
});


// quantity decrement
$(document).on('click', '.cv_cart_drawersub', function (e) {
    e.preventDefault();
    var $qtyInput = $(this).closest('.products-item-desc__qty-container').find('input.cart__qty-input');
    var currentQuantity = parseInt($qtyInput.val(), 10);

    if (currentQuantity > 1) {
        $("#overlay").show();
        $("#overlay_id").show();
        $qtyInput.val(currentQuantity - 1);
        var $qtySpan = $(this).closest('.products-item-desc__qty-container').find('span[data-quantity-input]');
        $qtySpan.text(currentQuantity - 1);
        updateCartAfterQuantityChange($(this), currentQuantity - 1);
    } else {
        $("#overlay").hide();
        $("#overlay_id").hide();
    }

    if (currentQuantity > 1) {
        // Decrement the quantity immediately for responsive UI update
        $qtyInput.val(currentQuantity - 1);
        // Update corresponding UI elements
        updateCartUI($(this), currentQuantity - 1);
        // Send the update to the server
        sendCartUpdate($(this));
    } else if (currentQuantity === 1) {
        // Handle minimum quantity logic, hide overlay if needed
        $("#overlay, #overlay_id").hide();
    }

    function updateCartUI($button, newQuantity) {
        var $qtySpan = $button.closest('.products-item-desc__qty-container').find('span[data-quantity-input]');
        var $totalPriceElement = $button.closest('.side-cart-container__products-item').find('.side-cart-container__total-price .theme-money');
        var pricePerItem = parseFloat($totalPriceElement.text().split(' = ')[0].replace('₹', '').replace(',', '').trim());

        // Update the quantity span and the total price
        $qtySpan.text(newQuantity);
        var newTotalPrice = pricePerItem * newQuantity;
        var formattedPrice = '₹ ' + newTotalPrice.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        $totalPriceElement.text(pricePerItem + ' = ' + formattedPrice);
    }

    function sendCartUpdate($button) {
        var formData = $button.parents('#cartForm').serialize();
        $.ajax({
            url: '/cart/update',
            type: 'POST',
            dataType: 'HTML',
            data: formData,
            success: function (response) {
                console.log('Cart successfully updated.');
                // Potentially adjust UI based on response if needed
            },
            error: function () {
                console.error('Failed to update cart.');
                // Consider reverting UI changes if the server update fails
            }
        });
    }
});

function updateCartAfterQuantityChange($button, newQuantity) {
    var formData = $button.parents('form').serialize();

    $.ajax({
        url: '/cart/update',
        type: 'POST',
        data: formData,
        success: function (response) {
            console.log('Cart successfully updated.');
            // Hide overlay after processing
            $("#overlay").hide();
            $("#overlay_id").hide();
        },
        error: function () {
            console.error('Failed to update cart.');
            // Optionally revert the quantity change in UI
            var $qtyInput = $button.closest('.products-item-desc__qty-container').find('input.cart__qty-input');
            var $qtySpan = $button.closest('.products-item-desc__qty-container').find('span[data-quantity-input]');
            $qtyInput.val(newQuantity + 1);
            $qtySpan.text(newQuantity + 1);

            // Hide overlay after processing
            $("#overlay").hide();
            $("#overlay_id").hide();
        }
    });
}

$(document).on('click', '.cv_Custom_add_to_Cart_pair', function (e) {
    e.preventDefault();
    $('#overlay_id').show();
    $("#overlay").show();

    var ProductID = $(this).attr('vid');
    var data_lenght = $('.cv_repeat_cart').length;
    var old_product = $('.cv_repeat_cart').attr('data-varid');
    var removeVar = { id: old_product, quantity: 0 }
    var first_inv = $('.cv_repeat_cart[data-line="1"]').attr('data-quantity');
    var sec_inv = $('.cv_repeat_cart[data-line="2"]').attr('data-quantity');

    if (data_lenght == 1) {
        $.ajax({
            url: '/cart/change',
            type: 'POST',
            data: removeVar,
            dataType: 'html',
            success: function (response) {
                $.ajax({
                    url: '/cart/add',
                    type: 'POST',
                    data: {
                        id: ProductID,
                        quantity: first_inv,
                    },
                    dataType: 'html',
                    success: function (response) {
                        $('.site-header__cart-count').html($(response).find('.site-header__cart-count').html())
                        $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('cart_drawer_open');
                        $('html').addClass('drawer_open_overlay');
                        $("#overlay").hide();
                        $('#overlay_id').hide();
                        $('.cv_custom_right_Contents_cart_mini').addClass('cv_custom_right_contente_full_width');
                    }

                });

            }
        });
    }
    else if (first_inv == sec_inv) {
        $.ajax({
            url: '/cart/clear',
            type: 'POST',
            success: function (response) {
                $.ajax({
                    url: '/cart/add',
                    type: 'POST',
                    data: {
                        id: ProductID,
                        quantity: first_inv,
                    },
                    dataType: 'html',
                    success: function (response) {
                        $('.site-header__cart-count').html($(response).find('.site-header__cart-count').html())
                        $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('cart_drawer_open');
                        $('html').addClass('drawer_open_overlay');
                        $("#overlay").hide();
                        $('#overlay_id').hide();
                        $('.cv_custom_right_Contents_cart_mini').addClass('cv_custom_right_contente_full_width');
                    }

                });
            }
        })
    }

    else {
        $.ajax({
            url: '/cart/add',
            type: 'POST',
            data: {
                id: ProductID,
                quantity: 1,
            },
            dataType: 'html',
            success: function (response) {
                $('.site-header__cart-count').html($(response).find('.site-header__cart-count').html())
                $('.cart_drawer').html($(response).filter('.cart_drawer').html()).addClass('cart_drawer_open');
                $('html').addClass('drawer_open_overlay');
                $("#overlay").hide();
                $('#overlay_id').hide();
                $('.cv_custom_right_Contents_cart_mini').addClass('cv_custom_right_contente_full_width');
            }

        });
    }

});


$(document).on('click', '.cv_custom_site_mobile_menu_bar', function (e) {
    $('.icon-hamburger').toggle();
    $('.cv_Custom_desktop_cart_part').hide();
    $('.cv_Custom_cross_icon_menu').toggle();
    $('.mobile-nav-wrapper').toggleClass('cv_Custom_open_nav');
    $('.cv_Custom_mobile_cross_icon_button').toggle();
    $('.cv_Custom_cross_icon_menu').toggle();
    $('html').addClass('cv_Custom_menu_bar_overlay');

});
$('.cv_custom_cross_icon_menu').click(function () {
    setTimeout(function () {
        $('.cv_Custom_desktop_cart_part').show();
    }, 100);
    $('.icon-hamburger').toggle();
    $('.mobile-nav-wrapper').toggleClass('cv_Custom_open_nav');
    $('html').removeClass('cv_Custom_menu_bar_overlay');
});